import { WorkDay, WorkSchedule } from '@/modules/common/api';
import { OrganizationFormValues } from '@/modules/onboarding/organization-setup';
import { DayOfWeek, dayOfWeekToOrdinal } from '@/types/day-of-week';

/**
 * Parse time string (e.g. "9:00am", "23:34") to minutes since midnight
 */
export function parseTimeToMinuteOfTheDay(timeStr: string | null | undefined): number {
  if (!timeStr) return 0;

  // Match 24-hour format (e.g., 23:34)
  const match24h = timeStr.match(/^([01]?\d|2[0-3]):([0-5]\d)$/);
  if (match24h) {
    const hours = parseInt(match24h[1], 10);
    const minutes = parseInt(match24h[2], 10);
    return hours * 60 + minutes;
  }

  // Match 12-hour format with am/pm (e.g., 9:00am)
  const match12h = timeStr.match(/^(\d{1,2}):(\d{2})(am|pm)$/i);
  if (match12h) {
    let hours = parseInt(match12h[1], 10);
    const minutes = parseInt(match12h[2], 10);
    const period = match12h[3];
    if (period?.toLowerCase() === 'pm' && hours < 12) hours += 12;
    if (period?.toLowerCase() === 'am' && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }

  return 0;
}

/**
 * Converts form workSchedule to API workScheduleRequest format
 */
export function parseWorkSchedule(values: OrganizationFormValues): WorkSchedule {
  const workScheduleDays: WorkDay[] = [];

  Object.entries(values.workSchedule || {}).forEach(([dayName, dayData]) => {
    if (dayData?.enabled && dayData.startTime && dayData.endTime) {
      const dayOfWeek = DayOfWeek[dayName as keyof typeof DayOfWeek];
      const startTimeMinutes = parseTimeToMinuteOfTheDay(dayData.startTime);
      const endTimeMinutes = parseTimeToMinuteOfTheDay(dayData.endTime);
      const workDay = new WorkDay(dayOfWeekToOrdinal(dayOfWeek), startTimeMinutes, endTimeMinutes);
      workScheduleDays.push(workDay);
    }
  });

  return { days: workScheduleDays };
}
